import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromEcommerceProductPublishing from './e-commerce-product-publishing.reducer';

export const getState = createFeatureSelector<fromEcommerceProductPublishing.State>(
  fromEcommerceProductPublishing.eCommerceProductPublishingFeatureKey,
);
export const getIsPublishingProcessMonitoringActive = createSelector(
  getState,
  state => state?.isPublishingProcessMonitoringActive,
);
export const getStatuses = createSelector(getState, state => state?.statuses || []);
